









import {Component} from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class YesNoNumberInput extends Vue {
    static COMPONENT_NAME = 'yes-no-number-input'
}

